import React from 'react'

export function DashboardFooterLogo() {
  return (
    <div className='column column-center' style={{ opacity: '60%', padding: '24px 0px' }}>
      <img src='images/njsig-logo-1.png' style={{ width: 100, filter: 'grayscale(1)' }} alt='' />
    </div>
  )
}
